<div class="modal-with-one-input-container">
  <div class="header-container">
    <h2>{{ 'medicalHistory.medicalNewRecordModal.add' | translate }}</h2>
    <p>
      {{ 'medicalHistory.medicalNewRecordModal.insert_here' | translate }}
      {{ 'medicalHistory.medicalNewRecordModal.and_date' | translate }}
    </p>
  </div>

  <ds-input-text [label]="'insertEmail' | translate" [control]="email" [placeholder]="'Email'"></ds-input-text>
  <div class="button-container">
    <ds-button class="button-exit" [text]="'buttons.exit' | translate" [styleType]="'empty-main'" [width]="'small'" (click)="close()"></ds-button>
    <ds-button class="button-register" [text]="'buttons.save' | translate" [width]="'small'" (click)="save()" [isDisabled]="email.invalid"></ds-button>
  </div>
</div>
